var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5083 5.93042C15.7046 5.93042 14.9174 5.7708 14.189 5.46912C13.4611 5.16807 12.791 4.72371 12.2229 4.15555C11.2656 3.19831 10.0394 2.57187 8.72105 2.35094C8.36955 2.29209 8.01147 2.26172 7.65024 2.26172H7.30628H5.64975H5.56278L5.57006 2.26975C5.37022 2.30721 5.21875 2.48195 5.21875 2.69271V14.9475H8.37702V5.35141L8.56444 5.55715C8.61545 5.61362 8.66766 5.66821 8.72105 5.72224C9.90047 6.9265 11.4714 7.53657 13.0466 7.53657C14.3106 7.53657 15.5777 7.14379 16.6492 6.34887C16.8283 6.21598 16.7314 5.93042 16.5083 5.93042V5.93042Z",
    fill: "url(#paint0_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25493 14.304C8.80615 15.7824 7.43228 17.6597 5.18632 18.4971C2.94042 19.3344 0.672876 18.8147 0.121661 17.3363C-0.429555 15.8579 0.944312 13.9806 3.19027 13.1432C5.43623 12.3059 7.70371 12.8256 8.25493 14.304V14.304Z",
    fill: "url(#paint1_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6457 6.34919C15.7499 7.01384 14.7164 7.39784 13.6623 7.50508C13.4563 7.52635 13.2494 7.53701 13.0426 7.53701C11.8387 7.53701 10.6372 7.18037 9.61134 6.47386C9.29498 6.25714 8.99462 6.00616 8.71703 5.72249C8.66382 5.66853 8.61131 5.61375 8.56036 5.55747L8.37331 5.35141V14.9478H6.45312V2.6929C6.45312 2.48227 6.60447 2.30733 6.8045 2.27006L6.79766 2.26172H7.64635C8.00757 2.26172 8.36572 2.29215 8.71709 2.35144C10.0357 2.57199 11.2616 3.19863 12.219 4.15606C12.7871 4.72415 13.457 5.16826 14.1848 5.46937C14.9134 5.7713 15.7012 5.93099 16.5043 5.93099C16.7278 5.93093 16.8244 6.2161 16.6457 6.34919V6.34919Z",
    fill: "url(#paint2_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88999 14.4529C7.29056 15.62 6.2921 17.102 4.65985 17.763C3.02759 18.424 1.37959 18.0137 0.97903 16.8467C0.578465 15.6796 1.57693 14.1976 3.20918 13.5365C4.84143 12.8755 6.48943 13.2857 6.88999 14.4529V14.4529Z",
    fill: "url(#paint3_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2018 2.88596C28.159 2.49876 27.831 2.21434 27.4652 2.2683L12.7843 4.43457C12.4603 4.48238 12.2188 4.78287 12.2188 5.13807V8.07743V21.4075H15.4956V7.59391L24.93 6.20185V19.2632H28.2068V5.71834V2.9718V2.88678C28.2051 2.88646 28.2034 2.88627 28.2018 2.88596V2.88596Z",
    fill: "url(#paint4_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1976 3.24609V19.2638H24.9207V6.20202L15.4864 7.59445V21.4076H13.1562V6.08569C13.1562 5.73055 13.3981 5.43019 13.722 5.38225L28.1976 3.24609Z",
    fill: "url(#paint5_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3224 20.249C16.0919 22.4911 14.1737 25.3382 11.038 26.6081C7.90224 27.878 4.73638 27.0898 3.96674 24.8476C3.19711 22.6055 5.11536 19.7584 8.2511 18.4885C11.3869 17.2187 14.5528 18.0069 15.3224 20.249Z",
    fill: "url(#paint6_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0333 18.1045C28.8028 20.3466 26.8847 23.1937 23.7489 24.4636C20.6132 25.7335 17.4473 24.9453 16.6777 22.7031C15.9081 20.461 17.8263 17.6139 20.962 16.344C24.0978 15.0741 27.2637 15.8623 28.0333 18.1045Z",
    fill: "url(#paint7_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.706 20.4248C14.3165 22.2036 12.7948 24.4623 10.3071 25.4697C7.81939 26.4771 5.30783 25.8519 4.69726 24.0731C4.08669 22.2943 5.60851 20.0357 8.09616 19.0282C10.5839 18.0208 13.0955 18.646 13.706 20.4248V20.4248Z",
    fill: "url(#paint8_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6279 18.5215C27.2384 20.3002 25.7166 22.5589 23.229 23.5664C20.7412 24.5738 18.2297 23.9485 17.6191 22.1698C17.0086 20.391 18.5304 18.1323 21.018 17.1249C23.5057 16.1175 26.0173 16.7427 26.6279 18.5215Z",
    fill: "url(#paint9_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4309 15.7568C23.4305 15.7568 23.4301 15.7569 23.4297 15.7569V24.5852C23.5362 24.5467 23.6429 24.5065 23.7495 24.4633C25.8983 23.5931 27.4749 21.9823 28.0071 20.3331L23.4309 15.7568Z",
    fill: "url(#paint10_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7622 16.0654C21.4963 16.1441 21.2293 16.2361 20.9623 16.3442C20.7047 16.4486 20.4562 16.5644 20.2159 16.6888L18.0078 24.3478C19.4029 25.2356 21.583 25.341 23.7492 24.4638C23.7851 24.4492 23.8201 24.4334 23.8557 24.4184L21.7622 16.0654Z",
    fill: "url(#paint11_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2702 22.5505L11.6172 18.8975L13.6077 24.9921C14.4002 24.258 14.9762 23.411 15.2702 22.5505V22.5505Z",
    fill: "url(#paint12_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7863 25.6576L10.8092 19.7595C10.1729 19.7479 10.1712 19.7479 9.53488 19.7363L7.88958 24.1095C7.64688 24.7546 7.02978 25.1818 6.34059 25.1818H4.10938C5.06756 27.1646 8.06721 27.8124 11.0413 26.608C11.6775 26.3504 12.2626 26.0269 12.7863 25.6576V25.6576Z",
    fill: "url(#paint13_linear_152_639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7576 23.5616C25.5674 23.5616 25.4039 23.4324 25.3606 23.2468L23.8046 16.6162C23.5377 15.4809 22.5757 14.6945 21.4099 14.6603C20.2464 14.6261 19.2365 15.3524 18.9027 16.4702L15.6631 27.3175C15.5878 27.5677 15.3893 27.6073 15.2767 27.6088C15.1665 27.6111 14.965 27.5754 14.8836 27.3267L12.5535 20.1813C12.2158 19.1471 11.2957 18.4604 10.2082 18.4315C9.12226 18.4042 8.16559 19.0399 7.77393 20.0544L6.52066 23.3008C6.4598 23.4567 6.30695 23.5616 6.13967 23.5616H1.06466C0.476675 23.5616 0 24.0383 0 24.6263C0 25.2143 0.476675 25.6909 1.06466 25.6909H6.1398C7.18086 25.6909 8.1322 25.0385 8.50711 24.0673L9.76038 20.8209C9.85086 20.5874 10.0456 20.5578 10.152 20.5601C10.2593 20.5632 10.4516 20.6034 10.5293 20.8414L12.8593 27.9875C13.2076 29.0537 14.1513 29.7381 15.2692 29.7381C15.2806 29.7381 15.292 29.7381 15.3034 29.7374C16.4373 29.7237 17.3787 29.0127 17.7034 27.9267L20.9431 17.0794C21.0176 16.8315 21.2062 16.7844 21.3461 16.7882C21.4891 16.7927 21.6723 16.8505 21.7317 17.103L23.2876 23.7335C23.5583 24.8864 24.5743 25.691 25.7576 25.691H30.9354C31.5234 25.691 32.0001 25.2143 32.0001 24.6263C32.0001 24.0384 31.5234 23.5617 30.9354 23.5617H25.7576V23.5616Z",
    fill: "url(#paint14_linear_152_639)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_639",
    x1: 7.18976,
    y1: 8.69253,
    x2: 18.7186,
    y2: 11.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_639",
    x1: 4.22895,
    y1: 15.9103,
    x2: 5.6581,
    y2: 19.0793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_639",
    x1: 9.67314,
    y1: 9.3361,
    x2: 4.6541,
    y2: 7.56167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_639",
    x1: 4.10455,
    y1: 16.0551,
    x2: 2.78641,
    y2: 12.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0527,
    stopColor: "#1FD1F9",
    stopOpacity: 0.053
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3027,
    stopColor: "#3ED8EC",
    stopOpacity: 0.303
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5478,
    stopColor: "#53DDE3",
    stopOpacity: 0.548
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7837,
    stopColor: "#61E0DE",
    stopOpacity: 0.784
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_639",
    x1: 17.998,
    y1: 5.42946,
    x2: 23.452,
    y2: 21.9245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_639",
    x1: 23.9357,
    y1: 15.7459,
    x2: 10.0199,
    y2: 1.1457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_639",
    x1: 7.50689,
    y1: 19.5517,
    x2: 13.185,
    y2: 27.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_639",
    x1: 21.0326,
    y1: 17.6393,
    x2: 24.9871,
    y2: 25.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_639",
    x1: 9.8807,
    y1: 23.3373,
    x2: 6.17975,
    y2: 17.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_639",
    x1: 22.8025,
    y1: 21.4339,
    x2: 19.1016,
    y2: 15.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_639",
    x1: 25.488,
    y1: 22.1987,
    x2: 20.8111,
    y2: 16.9135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_639",
    x1: 21.8161,
    y1: 21.0517,
    x2: 19.3826,
    y2: 20.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_639",
    x1: 15.3967,
    y1: 24.097,
    x2: 9.19893,
    y2: 19.3061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_639",
    x1: 10.049,
    y1: 25.1799,
    x2: 7.08318,
    y2: 22.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_639",
    x1: 15.4021,
    y1: 22.3605,
    x2: 17.5693,
    y2: 30.5731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT4);
export default __webpack_public_path__ + "static/media/t4.0762cfbb0ea3137cef2e01be3804e95a.svg";
export { ForwardRef as ReactComponent };